import lodashGet from "lodash/get";
import lodashHas from "lodash/has";
import lodashOrderBy from "lodash/orderBy";

import { ENDPOINT_TARGET, ENDPOINT_TARGET_TEST } from "@/common/constants/api";
import { TARGETS_TYPES } from "@/common/constants/targets";
import {
  httpGet,
  httpPost,
  httpPatch,
  httpDelete,
} from "@/services/api.service";

export { _getTargets as getTargets };
export { _getTarget as getTarget };
export { _saveTarget as saveTarget };
export { _testTarget as testTarget };
export { _editTarget as editTarget };
export { _deleteTarget as deleteTarget };

/// TARGETS

const _getTargets = async (params) => {
  try {
    const RESULT = await httpGet({
      url: ENDPOINT_TARGET,
      noCache: true,
    });
    const { data } = JSON.parse(RESULT);

    if (data && data.length) {
      const targetTypeIcons = {};
      TARGETS_TYPES.forEach((t) => {
        if (t.icon) {
          targetTypeIcons[t.targetType] = t.icon;
        }
      });

      data.forEach((item) => {
        if (item.targetType) {
          if (lodashHas(targetTypeIcons, item.targetType)) {
            item.icon = targetTypeIcons[item.targetType];
          }
        }
      });

      return lodashOrderBy(data, ["targetType"]);
    }
    return false;
  } catch (error) {
    console.error("Unable to get targets: ", JSON.stringify(error));
    return false;
  }
};

const _getTarget = async (params) => {
  try {
    if (!params || !params.targetId) {
      console.error("Unable to get target. No targetId.");
      return false;
    }
    const RESULT = await httpGet({
      url: `${ENDPOINT_TARGET}/${params.targetId}`,
      noCache: params.noCache,
    });
    const { data } = JSON.parse(RESULT);

    if (data) {
      return data;
    }
    return false;
  } catch (error) {
    console.error(
      `Unable to get target "${params.targetId}": `,
      JSON.stringify(error)
    );
    return false;
  }
};

const _saveTarget = async (params) => {
  if (!params) {
    return false;
  }

  _cleanParams(params);

  if (params.targetId) {
    return await _editTarget(params);
  }
  return await _addTarget(params);
};

const _addTarget = async (params) => {
  try {
    if (!params || !params.targetType) {
      return false;
    }

    let postRes = await httpPost({
      url: `${ENDPOINT_TARGET}`,
      data: JSON.parse(JSON.stringify(params)),
    });
    postRes = JSON.parse(postRes);

    if (postRes && postRes.data && postRes.data.targetId) {
      return postRes.data.targetId;
    }

    return false;
  } catch (error) {
    console.error("Unable to add target: ", JSON.stringify(error));
    if (lodashHas(error, "data.message")) {
      throw new Error(lodashGet(error, "data.message"));
    }
    return false;
  }
};

const _editTarget = async (params) => {
  try {
    if (!params || !params.targetType) {
      return false;
    }

    await httpPatch({
      url: `${ENDPOINT_TARGET}/${params.targetId}`,
      data: JSON.parse(JSON.stringify(params)),
    });

    return true;
  } catch (error) {
    console.error("Unable to edit target: ", JSON.stringify(error));
    if (lodashHas(error, "data.message")) {
      throw new Error(lodashGet(error, "data.message"));
    }
    return false;
  }
};

const _deleteTarget = async (params) => {
  try {
    if (!lodashGet(params, "targetId")) {
      console.error("Unable to delete target. No target id.");
      return false;
    }
    await httpDelete({
      url: `${ENDPOINT_TARGET}/${params.targetId}`,
      noCache: true,
    });

    return true;
  } catch (error) {
    console.error(
      `Unable to delete target "${params.targetId}": `,
      JSON.stringify(error)
    );
    return false;
  }
};

const _testTarget = async (params) => {
  try {
    if (!params || !params.targetType) {
      return false;
    }

    _cleanParams(params);

    await httpPost({
      url: `${ENDPOINT_TARGET_TEST}`,
      data: JSON.parse(JSON.stringify(params)),
    });

    return true;
  } catch (error) {
    console.error("Unable to test target: ", JSON.stringify(error));
    if (lodashHas(error, "data.message")) {
      throw new Error(lodashGet(error, "data.message"));
    }
    return false;
  }
};

const _cleanParams = (params) => {
  if (lodashHas(params, "fields")) {
    delete params.fields;
  }
  if (lodashHas(params, "display")) {
    delete params.display;
  }
  if (lodashHas(params, "icon")) {
    delete params.icon;
  }
  if (lodashHas(params, "infoFieldKey")) {
    delete params.infoFieldKey;
  }
};
